<card-alerte *ngIf="listeAlertes?.length" [niveau]="niveauAlerte" [isCard]="true">
    <preview-alerte *ngFor="let alerte of listeAlertes" [alerte]="alerte"></preview-alerte>
</card-alerte>

<ng-container *ngIf="!isRgpdSuspendu">
    <list-view *ngIf="listeVehicule" [liste]="listeVehicule"></list-view>
</ng-container>
